import { AuthGuard } from './../shared/auth-guard';
import { PortalComponent } from './portal.component';
// import { ProductSignupComponent } from './products/product-signup/product-signup.component';
import { CustomerOptionsPrivilegeGuard, ProductSignUpPrivilegeGuard, PortalDisclaimerGuard } from '../shared/privilege-guard';
// import { MobileConfirmationPopup } from 'app/shared/mobile-confirmation-popup';
import { PortalDashboardComponent } from './portal-dashboard/portal-dashboard.component';
import { EqutiesComponent } from './portal-dashboard/equties/equties.component';
import { RequestComponent } from './profile/request/request.component';
import { CalsPortfolioComponent } from './portal-dashboard/equties/cals-portfolio/cals-portfolio.component';
import { CalsTransactionsComponent } from './portal-dashboard/equties/cals-transactions/cals-transactions.component';
import { LedgerComponent } from './portal-dashboard/ledger/ledger.component';
import { LedgerSummaryComponent } from './portal-dashboard/ledger/ledger-summary/ledger-summary.component';
import { LedgerPortfolioComponent } from './portal-dashboard/ledger/portfolio/ledger-portfolio.component';
import { EquitySummaryComponent } from './portal-dashboard/equties/equity-summary/equity-summary.component';
import { DownloadReportsComponent } from './portal-dashboard/equties/download-reports/download-reports.component';
import { ProfileComponent } from './profile/profile.component';
import { MarginTradingComponent } from './portal-dashboard/margin-trading/margin-trading.component';
import { MarginTradingSummaryComponent } from './portal-dashboard/margin-trading/margin-trading-summary/margin-trading-summary.component';
import { TradingPortfolioComponent } from './portal-dashboard/margin-trading/portfolio/trading-portfolio.component';
import { MarketInsightsComponent } from './portal-dashboard/market-insights/market-insights.component';
import { DscDashboardComponent } from './dsc-dashboard/dsc-dashboard.component';

export const portalRoutes = [
  {
    path: 'dashboard',
    component: PortalComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: PortalDashboardComponent,
        canActivate: [PortalDisclaimerGuard],
      },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [PortalDisclaimerGuard],
      },

      {
        path: 'equity',
        component: EqutiesComponent,
        canActivate: [PortalDisclaimerGuard],
      },
      {
        path: 'equity/summary/:investorCode',
        component: EquitySummaryComponent,
        canActivate: [PortalDisclaimerGuard],
        children: [
          {
            path: 'portfolio',
            component: CalsPortfolioComponent,
          },
          {
            path: 'transactions',
            component: CalsTransactionsComponent,
          },
          {
            path: 'requests',
            component: RequestComponent,
          },
          {
            path: 'download-statements',
            component: DownloadReportsComponent,
          },
        ],
      },

      {
        path: 'margin-trading',
        component: MarginTradingComponent,
        canActivate: [PortalDisclaimerGuard],
      },
      {
        path: 'margin-trading/summary/:investorCode',
        component: MarginTradingSummaryComponent,
        canActivate: [PortalDisclaimerGuard],
      },
      {
        path: 'margin-trading/portfolio/:investorCode',
        component: TradingPortfolioComponent,
        canActivate: [PortalDisclaimerGuard],
      },

      {
        path: 'ledger',
        component: LedgerComponent,
        canActivate: [PortalDisclaimerGuard],
      },
      {
        path: 'ledger/summary/:investorCode',
        component: LedgerSummaryComponent,
        canActivate: [PortalDisclaimerGuard],
      },
      {
        path: 'ledger/portfolio/:investorCode',
        component: LedgerPortfolioComponent,
        canActivate: [PortalDisclaimerGuard],
      },
      {
        path: 'v-stock-ver2',
        loadChildren: () =>
          import('./stock-picker-ver2/stock-picker-ver2.module').then(
            (m) => m.StockPickerVer2Module
          ),
        data: {
          title: 'CAL VSTOCK - CAL Portal',
        },
      },
    ],
  },
  {
    path: 'market-insights',
    component: MarketInsightsComponent,
    canActivate: [PortalDisclaimerGuard],
  },
  {
    path: 'dsc-dashboard',
    component: DscDashboardComponent,
    canActivate: [PortalDisclaimerGuard],
  },

  // {
  //   path: 'products',
  //   component: PortalComponent,
  //   canActivate: [AuthGuard],
  //   children: [
  //     {
  //       path: ':productId/signup',
  //       component: ProductSignupComponent,
  //       canActivate: [CustomerOptionsPrivilegeGuard, EmailConfirmationPopup, MobileConfirmationPopup, ProductSignUpPrivilegeGuard],
  //       animation: { value: 'signup' },
  //     },
  //   ],
  // },
];
